import React from 'react';
import styled from 'styled-components';
import { retinaImage } from 'polished';

import { assetize } from '../../utils/pureUtils';
import { useTranslate } from '../../translate/I18n';

import Box from '../atoms/Box';
import Button from '../atoms/Button';
import Text from '../atoms/Text';

const StyledContainer = styled('div')(({ theme }) => ({
  flex: '1',
  position: 'relative',
  zIndex: 1,
  '&:before': {
    content: '""',
    position: 'absolute',
    background: 'linear-gradient(180deg, rgba(250,250,250,1) 0%, rgba(232,232,232,1) 100%)',
    width: '39%',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: -1,
    [`@media (max-width: ${theme.breakpoints.xl})`]: {
      maxWidth: '450px'
    },
    [`@media (max-width: ${theme.breakpoints.md})`]: {
      width: '100%',
      maxWidth: '100%',
      background: 'linear-gradient(270deg, rgba(255,255,255,1) 20%, rgba(232,232,232,1) 100%)'
    }
  }
}));

const StyledImageContainer = styled('div')(({ theme }) => ({
  padding: '120px 10%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  maxWidth: '1600px',
  width: '100%',
  margin: '0 auto',
  [`@media (max-width: ${theme.breakpoints.xl})`]: {
    padding: '50px 10%'
  },
  [`@media (max-width: ${theme.breakpoints.lg})`]: {
    padding: '32px 8%'
  },
  [`@media (max-width: ${theme.breakpoints.md})`]: {
    padding: '80% 8% 58px'
  },
  ...retinaImage(
    '/assets/whitepaper/white-paper-mockup',
    'contain',
    'png',
    '/assets/whitepaper/white-paper-mockup@2x',
    '@2x'
  )
}));

const WhitePaper = () => {
  const { t } = useTranslate(['whitePaper']);

  return (
    <StyledContainer>
      <StyledImageContainer>
        <Box maxWidth={{ _: '100%', md: '330px', lg: '520px', xl: '620px' }} ml="auto">
          <Text color="main" styleName="wPsmall">
            {t('whitePaper:subtitle')}
          </Text>
          <Text tag="h2" styleName="wH2" mb={2}>
            {t('whitePaper:title')}
          </Text>
          <Text mb={4} maxWidth="460px">
            {t('whitePaper:description')}
          </Text>
          <Button
            href="https://beelance.hubspotpagebuilder.com/white-book-on-remote-work-within-the-it-sector"
            as={'a'}
            target="_blank"
            styleType="secondary"
            shape="rounded">
            {t('whitePaper:download')}
          </Button>
        </Box>
      </StyledImageContainer>
    </StyledContainer>
  );
};

export default WhitePaper;
